const getters = {
  approvalStatusTypes(state) {
    return state.statuses
  }
}

export default getters
